import { CardContent } from "@material-ui/core";

export default CardContent;
